import { type ComponentPropsWithoutRef, type ComponentRef, forwardRef } from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';
import { cn } from '@/utils';
export const SelectIcon = forwardRef<ComponentRef<typeof SelectPrimitive.Icon>, ComponentPropsWithoutRef<typeof SelectPrimitive.Icon> & {
  open: boolean;
}>(({
  className,
  children,
  open,
  ...props
}, ref) => {
  return <SelectPrimitive.Icon ref={ref} style={{
    transitionDuration: '0.24s'
  }} className={cn('transition-transform ease-in-out', open && 'rotate-180', className)} asChild {...props}>
      {children}
    </SelectPrimitive.Icon>;
});
SelectIcon.displayName = SelectPrimitive.Icon.displayName;